import React, { useContext, useRef } from 'react';
import { VirtuosoGrid } from 'react-virtuoso';
import styled from '@emotion/styled';
import { Stack } from '@mui/material';
import NoContentTextView from 'js/components/elements/NoContentTextView';
import PlaceholderContent from './PlaceholderContent';
import DomainItemCard from '../components/DomainItemCard';
import styles from './DataProducts.module.scss';
import { Nexset } from 'new/entities/Nexset';
import { fetchDatasetDoc, loadDomainItem } from 'js/actions';
import { MarketplaceContext } from '../Marketplace';
import useAppDispatch from 'js/hooks/useAppDispatch';

interface MainContentProps {
  items: Nexset[];
  domain: number;
  isLoading: boolean;
  setSelectedItem: (dataset: Nexset) => void;
}

const ItemContainer = styled.div`
  padding: 0.5rem;
  width: 50%;
  display: flex;
  flex: none;
  align-content: stretch;
  box-sizing: border-box;

  @media (min-width: 1442px) {
    width: 33%;
  }
`;

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
` as React.FC;

const placeholderArray = new Array(12).fill(0);

const MainContent = (props: MainContentProps) => {
  const { items, domain, isLoading, setSelectedItem } = props;
  const dispatch = useAppDispatch();
  const { containerRef } = useContext(MarketplaceContext);
  const timeoutEnterRef = useRef();
  const overlayRef = useRef<HTMLDivElement>(null);

  const onClickDetails = (dataset: Nexset) => {
    if (!dataset || !dataset.id) return;
    setSelectedItem(dataset);
    dispatch(fetchDatasetDoc(dataset?.id));
    dispatch(loadDomainItem(dataset?.id));
  };

  if (!isLoading && (!items || !items.length)) {
    return <NoContentTextView title={<div>No Nexsets detected for this Domain.</div>} />;
  }

  return (
    <Stack className={styles.dataProductsContent} padding="16px">
      <div ref={overlayRef} className={styles.overlay} />
      <VirtuosoGrid
        customScrollParent={containerRef.current}
        data={isLoading ? placeholderArray : items}
        components={{
          List: ListContainer,
          Item: ItemContainer,
          ScrollSeekPlaceholder: PlaceholderContent,
        }}
        itemContent={(index) =>
          isLoading ? (
            <PlaceholderContent />
          ) : (
            <DomainItemCard
              onClickDetails={onClickDetails}
              item={items[index]}
              domainId={domain}
              timeoutEnterRef={timeoutEnterRef}
              overlayRef={overlayRef}
            />
          )
        }
      />
    </Stack>
  );
};

export default MainContent;
